function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import Moment from "react-moment";
export class MomentDate extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(Moment, {
        tz: 'Australia/Adelaide',
        format: "DD/MM/YYYY"
      }, this.props.children);
    });
  }

}
export class MomentDateTime extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(Moment, {
        tz: 'Australia/Adelaide',
        format: "DD/MM/YYYY h:mm a"
      }, this.props.children);
    });
  }

}
export class MomentTime extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return (
        /*#__PURE__*/
        // <Moment tz={ 'Australia/Adelaide' } format="h:mm a">{ this.props.children }</Moment>
        // Should be change tz and format to variable with initial value.
        React.createElement(Moment, {
          tz: 'Australia/Adelaide',
          format: "HH:mm"
        }, this.props.children)
      );
    });
  }

}
export class MomentUnixDate extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(Moment, {
        unix: true,
        tz: 'Australia/Adelaide',
        format: "DD/MM/YYYY"
      }, this.props.children);
    });
  }

}
export class MomentUnixDateTime extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(Moment, {
        unix: true,
        tz: 'Australia/Adelaide',
        format: "DD/MM/YYYY h:mm a"
      }, this.props.children);
    });
  }

}